// noinspection DuplicatedCode

import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';

import {alertService} from '../../../services/AlertService';

import TableCard from "../../../components/tablecard/TableCard";
import ModalForm from "../../../components/modal/form/ModalForm";

import {getKegiatan, insertKegiatan, kegiatanSelector, updateKegiatan} from './kegiatanSlice';


import {Colors} from "../../../assets/Colors";

const KegiatanPage = ({}) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [firstLoading, setFirstLoading] = useState(false);
    const [start, setStart] = useState(0);
    const [count, setCount] = useState(5);
    const [page, setPage] = useState(1);
    const [maxPage, setMaxPage] = useState(0);
    const [search, setSearch] = useState('');
    const [searchFetch, setSearchFetch] = useState(false);
    const [insertFetch, setInsertFetch] = useState(false);
    const [updateFetch, setUpdateFetch] = useState(false);
    const [showModalAdd, setShowModalAdd] = useState(false);
    const [showModalEdit, setShowModalEdit] = useState(false);
    const [currentData, setCurrentData] = useState({});

    const kegiatan = useSelector(
        kegiatanSelector
    );


    useEffect(() => {
        dispatch(getKegiatan({
            start: start,
            count: count,
            search: '',
        }));

    }, []);

    useEffect(() => {

        if ((search !== '') && kegiatan.isGetSuccess && !kegiatan.isGetFetching) {
            let calc = kegiatan?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if ((calc % count) === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = kegiatan.data ? Math.ceil(calc / count) : 1;
            setSearchFetch(false);
            setMaxPage(tempMaxPage);
        } else if ((search === '') && kegiatan.isGetSuccess && !kegiatan.isGetFetching) {
            let calc = kegiatan?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if ((calc % count) === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = kegiatan.data ? Math.ceil(calc / count) : 1;
            setSearchFetch(false);
            setMaxPage(tempMaxPage);
        }

        if (!kegiatan?.isGetFetching && kegiatan.isGetSuccess && (maxPage === 0) && (firstLoading === false)) {
            let calc = kegiatan?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if ((calc % count) === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = kegiatan.data ? Math.ceil(calc / count) : 1;
            setMaxPage(tempMaxPage);
            setFirstLoading(true);
            dispatch(getKegiatan({
                start: start,
                count: count,
                search: search,
            }));
        }

        if (
            (insertFetch)
        ) {
            setInsertFetch(false);
            if (kegiatan.isGetSuccess) {
                alertService.success(kegiatan.message, {autoClose: true, keepAfterRouteChange: false});
                dispatch(getKegiatan({
                    start: start,
                    count: count,
                    search: search,
                }));
            }
        }

        if (
            (updateFetch)
        ) {
            setUpdateFetch(false);
            if (kegiatan.isUpdateSuccess) {
                alertService.success(kegiatan.message, {autoClose: true, keepAfterRouteChange: false});
                dispatch(updateKegiatan({
                    start: start,
                    count: count,
                    search: search,
                }));
            }
        }

    });

    // function handleGetKegiatan(params) {
    //   return dispatch(getKegiatan(params));
    // }

    function handleInsertKegiatan(param) {
        setInsertFetch(true);
        const params = {
            KelompokKegiatanID: param.dropdownKelompokKegiatanValue,
            SubKegiatanID: param.dropdownSubKegiatanValue,
            SatuanID: param.dropdownSatuanValue,
            NamaKegiatan: param.inputOneValue,
            MinUsage: param.inputNumberOneValue,
            Rate: param.inputNumberTwoValue,
        };

        dispatch(insertKegiatan(params));
    }

    function handleUpdateKegiatan(param) {
        setUpdateFetch(true);

        const params = {
            KelompokKegiatanID: param.dropdownKelompokKegiatanValue,
            SubKegiatanID: param.dropdownSubKegiatanValue,
            SatuanID: param.dropdownSatuanValue,
            NamaKegiatan: param.inputOneValue,
            MinUsage: param.inputNumberOneValue,
            Rate: param.inputNumberTwoValue,
            KegiatanID: currentData.KegiatanID,
            status: param.status,
        };
        dispatch(updateKegiatan(params));
    }

    function handleSearch(searchValue) {
        let params = {
            start: 0,
            count: 5,
            search: searchValue,
        }
        dispatch(getKegiatan(params));

        setStart(0);
        setCount(5);
        setSearch(searchValue);
        setSearchFetch(true);
    }

    function handleUpdatePage(newPage) {
        let newStart = (newPage * count) - count;

        let params = {
            start: newStart,
            count: count,
            search: search,
        }
        dispatch(getKegiatan(params));

        setPage(newPage)
        setStart(newStart)
    }

    function handleUpdateCount(newCount) {
        let calc = (kegiatan.count - 1);
        if (calc === 0) {
            calc = 1;
        }

        let params = {
            start: (newCount === "-1") ? 0 : start,
            count: (newCount === "-1") ? kegiatan.count : newCount,
            search: search,
        }
        dispatch(getKegiatan(params));

        setPage(1);
        setCount((newCount === "-1") ? kegiatan.count : newCount)
        setStart((newCount === "-1") ? 0 : start);
        setMaxPage((newCount === "-1") ? 1 : Math.ceil(calc / newCount))
    }

    function handleCurrentData(values) {
        setCurrentData(values);
    }

    function handleModal(status) {
        setShowModalAdd(status.showModalAdd);
        setShowModalEdit(status.showModalEdit);
    }

    if (!firstLoading) {
        return <div>loading</div>
    } else {
        return (

            <div className="md:ml-64">
                <div style={{background: Colors.primary}} className="pt-14 pb-16 px-3 md:px-8 h-auto">
                    <div className="container mx-auto max-w-full">
                        <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
                    </div>
                </div>

                <div className="px-3 md:px-8 h-auto -mt-32">
                    <div className="container mx-auto max-w-full">
                        <div className="grid grid-cols-1 px-4">
                            <TableCard
                                handleSearch={handleSearch}
                                searchPlaceholder="Kegiatan"
                                updatePage={handleUpdatePage}
                                updateCount={handleUpdateCount}
                                currentData={handleCurrentData}
                                currentPage={page}
                                maxPage={maxPage}
                                tableTitle="Master Kegiatan"
                                tableData={kegiatan.data}
                                colOneTitle="ID"
                                colOneData="KegiatanID"
                                colTwoTitle="Nama Kegiatan"
                                colTwoData="NamaKegiatan"
                                status="Status"

                                fetching={kegiatan.isGetFetching}
                                modal={handleModal}
                                editEnabled={true}

                            />
                        </div>
                    </div>
                </div>
                {showModalAdd &&
                    <ModalForm
                        showModal={showModalAdd}
                        addEnabled={true}
                        modal={handleModal}
                        modalTitle="Tambah Kegiatan"
                        dropdownKelompokKegiatan={true}
                        dropdownSubKegiatan={true}
                        dropdownSatuan={true}
                        inputOneTitle="Nama Kegiatan"
                        inputOneValue=""
                        inputNumberOneTitle="Min Usage"
                        inputNumberTwoTitle="Rate"
                        submitButtonTitle="Submit"
                        handleSubmit={handleInsertKegiatan}
                    />
                }
                {showModalEdit &&
                    <ModalForm
                        showModal={showModalEdit}
                        editEnabled={true}
                        id={currentData.KegiatanID}
                        modal={handleModal}
                        modalTitle="Ubah Kegiatan"
                        dropdownKelompokKegiatan={true}
                        dropdownKelompokKegiatanValue={currentData.KelompokKegiatanID}
                        dropdownSubKegiatan={true}
                        dropdownSubKegiatanValue={currentData.SubKegiatanID}
                        dropdownSatuan={true}
                        dropdownSatuanValue={currentData.SatuanID}
                        inputOneTitle="Nama Kegiatan"
                        inputOneValue={currentData.NamaKegiatan}
                        inputNumberOneTitle="Min Usage"
                        inputNumberOneValue={currentData.MinUsage}
                        inputNumberTwoTitle="Rate"
                        inputNumberTwoValue={currentData.Rate}
                        status={currentData.Status}
                        submitButtonTitle="Submit"
                        handleSubmit={handleUpdateKegiatan}
                    />
                }
            </div>

        )
    }

}


export default KegiatanPage;